import { isNaN, isNumber } from "lodash";

const validNumber = value => isNumber(value) && !isNaN(value);

export default validNumber;
